/* ANIMUS · Test de tono. Lógica en assets/animus-test-tono-logica.json. Estilos: bloque 9 de animus-sistema.css.
   Privacidad: las respuestas quedan en sessionStorage de este navegador. A GA4 solo va la estación y el subtono. */
(function () {
  var raiz = document.getElementById('an-tono');
  if (!raiz) return;
  var ENTRADA = raiz.innerHTML, CLAVE = 'an_tono_v1', L = null, datos = {}, S = { pantalla: 'entrada', r: {} };

  function blindar() {
    try { if (window.fbq) window.fbq('set', 'autoConfig', false); } catch (e) {}
    try { if (window.clarity) window.clarity('stop'); } catch (e) {}
  }
  blindar(); window.addEventListener('load', blindar);

  try { var g = JSON.parse(sessionStorage.getItem(CLAVE) || 'null'); if (g && g.r) S = g; } catch (e) {}
  function guardar() { try { sessionStorage.setItem(CLAVE, JSON.stringify(S)); } catch (e) {} }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cop(c) { return '$' + Math.round(c / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function mide(ev, p) { try { if (window.gtag) window.gtag('event', ev, p || {}); } catch (e) {} }
  function img(nombre) { return (raiz.getAttribute('data-img-base') || '').replace('__N__', nombre); }
  var precargadas = {};
  function precarga(i) { var q = L && L.preguntas[i]; if (!q) return; q.opciones.forEach(function (o) { if (precargadas[o.img]) return; precargadas[o.img] = 1; var im = new Image(); im.src = img(o.img); }); }
  function enfoca(sel) { var el = raiz.querySelector(sel); if (el) { el.focus({ preventScroll: true }); raiz.scrollIntoView({ block: 'start' }); } }

  function subtono(r) {
    var n = { fria: 0, calida: 0, neutra: 0 };
    ['venas', 'joyeria', 'sol'].forEach(function (k) { if (n[r[k]] != null) n[r[k]]++; });
    if (n.fria >= 2) return 'fria';
    if (n.calida >= 2) return 'calida';
    return 'neutra';
  }

  function variante(tipo, tono) {
    var p = datos[L.productos[tipo]];
    if (!p) return null;
    return p.variants.filter(function (v) { return v.title === tono && v.available; })[0] || null;
  }

  function recomendaciones(r) {
    var sub = subtono(r), prof = r.profundidad, out = [];
    var lista = (L.blush[sub] || {})[prof] || [];
    var disponibles = lista.filter(function (t) { return variante('blush', t); });
    var blush = disponibles.slice(0, 2);
    if (r.efecto === 'visible' && disponibles[2]) blush = [disponibles[0], disponibles[2]];
    var bronzer = (L.bronzer[sub] || {})[prof];
    var lip = r.efecto === 'natural' ? 'Translúcido' : (L.lip[sub] || {})[prof];
    var items = blush.map(function (t) { return { tipo: 'blush', tono: t }; });
    var bz = { tipo: 'bronzer', tono: bronzer };
    if (r.efecto === 'bronceado') items.unshift(bz); else items.push(bz);
    items.push({ tipo: 'lip', tono: lip });
    items.forEach(function (it) { it.v = variante(it.tipo, it.tono); if (it.v) out.push(it); });
    return { sub: sub, estacion: (L.estaciones[sub] || {})[prof], items: out };
  }

  /* ---------- pantallas ---------- */
  function pintaPregunta(i) {
    var q = L.preguntas[i], sel = S.r[q.id], total = L.preguntas.length;
    var barras = L.preguntas.map(function (x, k) { return '<li' + (k <= i ? ' data-lleno' : '') + '></li>'; }).join('');
    var ops = q.opciones.map(function (o) {
      return '<li><button type="button" class="an-tono-opcion" aria-pressed="' + (sel === o.id) + '" data-op="' + esc(o.id) + '">' +
        '<img src="' + esc(img(o.img)) + '" alt="" width="300" height="300" loading="eager" decoding="async">' +
        '<span class="an-tono-opcion__texto">' + esc(o.texto) + '</span></button></li>';
    }).join('');
    raiz.innerHTML =
      '<div class="an-test-pasos"><div class="an-test-barra"><div class="an-test-barra__fila">' +
      '<button type="button" class="an-test-atras" data-accion="atras">Atrás</button>' +
      '<p class="an-test-etiqueta">Pregunta ' + (i + 1) + ' de ' + total + '</p></div>' +
      '<ol class="an-test-progreso" aria-hidden="true">' + barras + '</ol></div>' +
      '<div class="an-test-pregunta">' +
      '<h2 class="an-test-pregunta__titulo" id="an-tono-q" tabindex="-1">' + esc(q.texto) + '</h2>' +
      (q.ayuda ? '<p class="an-test-ayuda">' + esc(q.ayuda) + '</p>' : '') +
      '<ul class="an-tono-opciones an-tono-opciones--' + q.opciones.length + '" role="group" aria-labelledby="an-tono-q" data-pregunta="' + q.id + '">' + ops + '</ul></div></div>';
    precarga(i + 1);
    enfoca('#an-tono-q');
  }

  function cargarProductos() {
    var hs = Object.keys(L.productos).map(function (k) { return L.productos[k]; });
    if (L.skincare) Object.keys(L.skincare.suero).forEach(function (k) { var h = L.skincare.suero[k]; if (hs.indexOf(h) < 0) hs.push(h); });
    return Promise.all(hs.map(function (h) {
      return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) { if (p) datos[h] = p; }).catch(function () {});
    }));
  }

  function tarjeta(it) {
    var p = datos[L.productos[it.tipo]], v = it.v;
    var src = (v.featured_image && v.featured_image.src) || p.featured_image || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=320';
    var frase = (it.tipo === 'lip' && L.frases_lip[it.tono]) || L.frases[it.tono] || '';
    return '<li class="an-test-color__item">' +
      '<a class="an-test-color__foto" href="' + esc(p.url + '?variant=' + v.id) + '" tabindex="-1" aria-hidden="true">' + (src ? '<img src="' + esc(src) + '" alt="" width="160" height="160" loading="lazy">' : '') + '</a>' +
      '<div class="an-test-color__info"><a class="an-test-color__nombre" href="' + esc(p.url + '?variant=' + v.id) + '">' + esc(L.nombres[it.tipo]) + ' · ' + esc(it.tono) + '</a>' +
      '<span class="an-test-color__frase">' + esc(frase) + '</span>' +
      '<div class="an-test-color__compra"><span class="an-test-precio__actual">' + cop(v.price) + '</span>' +
      '<button type="button" class="an-test-boton an-test-boton--borde" data-accion="agregar" data-variante="' + v.id + '" data-tipo="' + it.tipo + '">Agregar</button></div>' +
      '</div></li>';
  }

  function pintaResultado() {
    var rec = recomendaciones(S.r), est = L.textos_estacion[rec.estacion] || { titulo: '', texto: '' };
    var total = rec.items.reduce(function (a, it) { return a + it.v.price; }, 0), n = rec.items.length;
    var umbral = +(raiz.getAttribute('data-umbral') || 19500000), falta = umbral - total;
    var envio = falta > 0 ? 'Te faltan <strong>' + cop(falta) + '</strong> para el envío gratis.' : 'Tienes envío gratis.';
    var lista = rec.items.map(function (it) { return '<li><span>' + esc(L.nombres[it.tipo]) + ' · ' + esc(it.tono) + '</span><span>' + cop(it.v.price) + '</span></li>'; }).join('');
    var comprar = function (clase) { return '<button type="button" class="an-test-boton ' + clase + '" data-accion="comprar-tonos"' + (n ? '' : ' disabled') + '>Comprar mis tonos</button>'; };
    raiz.innerHTML =
      '<div class="an-test-resultado">' +
      '<p class="an-test-etiqueta">Tu resultado</p>' +
      '<h1 class="an-test-resultado__titulo" id="an-tono-rt" tabindex="-1">Tu estación es ' + esc(est.titulo) + '</h1>' +
      '<p class="an-tono-subtono">' + esc(L.subtonos_texto[rec.sub]) + '</p>' +
      '<p class="an-test-resumen">' + esc(est.texto) + '</p>' +
      '<div class="an-test-resultado__grid"><div>' +
      '<h2 class="an-tono-h2">Tus tonos ÁNIMUS</h2>' +
      '<ul class="an-test-color__lista" data-tonos>' + rec.items.map(tarjeta).join('') + '</ul>' +
      '<p class="an-test-nota" data-mensaje role="status" aria-live="polite"></p>' +
      '<div class="an-tono-skin" data-skin-caja>' + htmlSkin() + '</div>' +
      '<p class="an-test-nota">' + esc(L.aviso) + '</p>' +
      '<p class="an-tono-acciones"><button type="button" class="an-test-enlace" data-accion="rehacer">Hacer el test otra vez</button> · ' +
      '<a class="an-test-enlace" href="' + esc(whatsapp(rec)) + '" target="_blank" rel="noopener">Asesoría de color por WhatsApp</a></p>' +
      '</div>' +
      '<aside class="an-test-compra-panel" aria-label="Tus tonos"><p class="an-test-etiqueta">Tus tonos · ' + n + (n === 1 ? ' producto' : ' productos') + '</p><ul>' + lista + '</ul>' +
      '<div class="an-test-compra-panel__total"><span>Subtotal</span><strong>' + cop(total) + '</strong></div>' +
      '<p class="an-test-nota an-test-compra-panel__envio">' + envio + '</p>' + comprar('an-test-boton--ancho') +
      (n ? '<p class="an-test-compra-panel__agregar"><button type="button" class="an-test-enlace" data-accion="agregar-todos">Agregar al carrito y seguir viendo</button></p>' : '') + '</aside>' +
      '</div></div>' +
      '<div class="an-test-compra-barra" data-visible><div><span class="an-test-etiqueta">' + n + ' tonos</span><span class="an-test-compra-barra__total">' + cop(total) + '</span></div>' + comprar('') + '</div>';
    if (!S.medido) { S.medido = true; guardar(); mide('test_tono_resultado', { estacion: rec.estacion, subtono: rec.sub }); }
    enfoca('#an-tono-rt');
  }

  function comprarTonos(boton) {
    var ids = [].map.call(raiz.querySelectorAll('[data-tonos] [data-accion="agregar"]'), function (x) { return +x.getAttribute('data-variante'); });
    raiz.querySelectorAll('[data-accion="comprar-tonos"]').forEach(function (b) { b.setAttribute('aria-disabled', 'true'); b.textContent = 'Preparando tu compra'; });
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var hay = {}; (c.items || []).forEach(function (x) { hay[x.variant_id] = 1; });
      var nuevos = ids.filter(function (id) { return !hay[id]; }).map(function (id) { return { id: id, quantity: 1 }; });
      return nuevos.length ? fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: nuevos }) }).then(function (r) { if (!r.ok) throw new Error('add'); }) : null;
    }).then(function () {
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ attributes: { 'Origen': 'test-tono' } }) }).catch(function () {});
    }).then(function () {
      mide('test_tono_comprar', { productos: ids.length });
      window.location.href = '/checkout';
    }).catch(function () {
      var m = raiz.querySelector('[data-mensaje]'); if (m) m.textContent = 'No pudimos preparar tu compra. Intenta de nuevo en un momento.';
      raiz.querySelectorAll('[data-accion="comprar-tonos"]').forEach(function (b) { b.removeAttribute('aria-disabled'); b.textContent = 'Comprar mis tonos'; });
    });
  }

  /* ---------- Completa con skincare: pregunta rápida y 2 sueros ---------- */
  function tarjetaSuero(h) {
    var p = datos[h]; if (!p) return '';
    var v = p.variants.filter(function (x) { return x.available && /30/i.test(x.title); })[0] || p.variants.filter(function (x) { return x.available; })[0];
    if (!v) return '';
    var src = (v.featured_image && v.featured_image.src) || p.featured_image || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=320';
    return '<li class="an-test-color__item">' +
      '<a class="an-test-color__foto" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (src ? '<img src="' + esc(src) + '" alt="" width="160" height="160" loading="lazy">' : '') + '</a>' +
      '<div class="an-test-color__info"><a class="an-test-color__nombre" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="an-test-color__frase">' + esc(L.skincare.frases[h] || '') + '</span>' +
      '<div class="an-test-color__compra"><span class="an-test-precio__actual">' + cop(v.price) + '</span>' +
      '<button type="button" class="an-test-boton an-test-boton--borde" data-accion="agregar" data-variante="' + v.id + '" data-tipo="skincare">Agregar</button></div>' +
      '</div></li>';
  }
  function htmlSkin() {
    var k = L.skincare; if (!k) return '';
    var sel = S.skin, lista = '';
    if (sel && k.suero[sel]) {
      var a = k.suero[sel], b = a === k.complemento ? k.complemento_si_ya_esta : k.complemento;
      lista = '<ul class="an-test-color__lista">' + [a, b].map(tarjetaSuero).join('') + '</ul>';
    }
    return '<h2 class="an-tono-h2">' + esc(k.titulo) + '</h2><p class="an-test-tono__pregunta">' + esc(k.pregunta) + '</p>' +
      '<div class="an-test-tono__chips" role="group" aria-label="' + esc(k.pregunta) + '">' +
      k.opciones.map(function (o) { return '<button type="button" class="an-test-chip" data-skin="' + o[0] + '" aria-pressed="' + (sel === o[0]) + '">' + esc(o[1]) + '</button>'; }).join('') + '</div>' +
      lista + '<p class="an-test-nota" data-mensaje-skin role="status" aria-live="polite"></p><p class="an-tono-rutina"><a class="an-test-enlace" href="/pages/test-de-piel">' + esc(k.enlace_test) + '</a></p>';
  }

  function whatsapp(rec) {
    var base = raiz.getAttribute('data-whatsapp') || 'https://wa.me/573181975205';
    var t = 'Hola, hice el test de tono en animuslb.com. Mi estación es ' + ((L.textos_estacion[rec.estacion] || {}).titulo || '') + ' y quiero asesoría de color.';
    return base + '?text=' + encodeURIComponent(t);
  }

  function agregar(lineas, boton) {
    var msj = boton.getAttribute('data-tipo') === 'skincare' ? raiz.querySelector('[data-mensaje-skin]') : raiz.querySelector('[data-mensaje]'), txt = boton.textContent;
    boton.setAttribute('aria-disabled', 'true');
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: lineas }) })
      .then(function (res) {
        if (!res.ok) throw new Error('add');
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        var hechos = boton.getAttribute('data-accion') === 'agregar-todos' ? [].slice.call(raiz.querySelectorAll('[data-tonos] [data-accion="agregar"]')).concat([boton]) : [boton];
        hechos.forEach(function (x) { x.textContent = x === boton && x.getAttribute('data-accion') === 'agregar-todos' ? 'Tus tonos están en el carrito' : 'En tu carrito'; x.classList.add('an-test-boton--hecho'); x.setAttribute('data-hecho', '1'); x.setAttribute('aria-disabled', 'true'); });
        if (msj) msj.innerHTML = 'Quedó en tu carrito. <a class="an-test-enlace" href="/cart" data-ver-carrito>Ver carrito</a>';
        mide('test_tono_agregar', { productos: lineas.length });
      })
      .catch(function () { if (msj) msj.textContent = 'No pudimos agregarlo. Intenta de nuevo en un momento.'; })
      .then(function () { if (!boton.getAttribute('data-hecho')) { boton.removeAttribute('aria-disabled'); boton.textContent = txt; } });
  }

  function pinta() {
    if (S.pantalla === 'resultado') return cargarProductos().then(pintaResultado);
    var i = typeof S.pantalla === 'number' ? S.pantalla : -1;
    if (i >= 0 && L.preguntas[i]) return pintaPregunta(i);
    raiz.innerHTML = ENTRADA;
  }

  function ir(p, empuja) {
    S.pantalla = p; guardar();
    if (empuja) try { history.pushState({ anTono: p }, ''); } catch (e) {}
    pinta();
  }

  raiz.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || !raiz.contains(b) || b.getAttribute('aria-disabled') === 'true') return;
    var acc = b.getAttribute('data-accion');
    if (acc === 'empezar') { if (!L) return; S = { pantalla: 0, r: {} }; mide('test_tono_inicio'); return ir(0, true); }
    if (acc === 'atras') { return history.back(); }
    if (acc === 'rehacer') { S = { pantalla: 0, r: {} }; return ir(0, true); }
    if (acc === 'agregar') return agregar([{ id: +b.getAttribute('data-variante'), quantity: 1 }], b);
    if (acc === 'comprar-tonos') return comprarTonos(b);
    if (acc === 'agregar-todos') {
      var ids = [].map.call(raiz.querySelectorAll('[data-tonos] [data-accion="agregar"]'), function (x) { return { id: +x.getAttribute('data-variante'), quantity: 1 }; });
      return agregar(ids, b);
    }
    var sk = b.getAttribute('data-skin');
    if (sk) { S.skin = sk; guardar(); var caja = raiz.querySelector('[data-skin-caja]'); if (caja) caja.innerHTML = htmlSkin(); mide('test_tono_skincare', { objetivo: sk }); return; }
    var op = b.getAttribute('data-op');
    if (op) {
      var ul = b.closest('[data-pregunta]'), qid = ul.getAttribute('data-pregunta'), i = S.pantalla;
      S.r[qid] = op; S.medido = false;
      [].forEach.call(ul.querySelectorAll('.an-tono-opcion'), function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      setTimeout(function () { ir(i + 1 < L.preguntas.length ? i + 1 : 'resultado', true); }, 180);
    }
  });

  window.addEventListener('popstate', function (e) {
    var p = e.state && e.state.anTono;
    if (p == null) p = 'entrada';
    S.pantalla = p; guardar(); pinta();
  });

  fetch(raiz.getAttribute('data-logica')).then(function (r) { return r.json(); }).then(function (l) {
    L = l;
    precarga(0); precarga(1);
    if (S.pantalla !== 'entrada') { try { history.replaceState({ anTono: S.pantalla }, ''); } catch (e) {} pinta(); }
    cargarProductos();
  }).catch(function () {
    var r = raiz.querySelector('[data-respaldo]'); if (r) r.hidden = false;
  });

  /* «Ver carrito» abre el carrito lateral del tema; si no existe, va a /cart */
  raiz.addEventListener('click', function (e) {
    var a = e.target.closest('[data-ver-carrito]'); if (!a) return;
    var t = document.querySelector('[data-drawer-toggle="drawer-cart"]');
    if (t) { e.preventDefault(); t.click(); }
  });
})();
